import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class TorqueDirectionReferenceService extends BaseReferenceService {
  constructor() {
    super('TorqueDirectionReference');
  }
}
